import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.reports');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-reports',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.reports/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageReportsComponent implements OnInit {
    public activeSectionId: string = 'section-1';
    public rightTab: string = 'citations';
    public aiSuggestion: string = '';
    public showAiPanel: boolean = false;

    public sections: any[] = [
        { id: 'section-1', title: '서론', status: 'ready', statusLabel: '검토 완료', words: 420,
          content: '동해와 독도 관련 사료를 중심으로 동북아 해양 인식의 차이를 정리한다. 본 보고서는 조선·일본·중국 측 문헌을 병렬 검토하고, 국제 표기 논쟁과 역사왜곡 대응 프레임을 함께 다룬다. 연구 범위는 17세기 안용복 사건부터 2020년 IHO 디지털 전환 결정까지를 포괄하며, 각 시기별 핵심 쟁점을 선별하여 분석한다.' },
        { id: 'section-2', title: '사료 분석: 독도 영유권', status: 'ready', statusLabel: '검토 완료', words: 1480,
          content: '독도 영유권 관련 사료는 조선 숙종실록, 일본 돗토리번 답변서, 태정관 지령(1877), 대한제국 칙령 제41호를 중심으로 검토한다. 특히 태정관 지령은 일본 메이지 정부의 최고 행정기관이 독도를 일본 영토에서 제외한 공식 결정이라는 점에서 결정적 사료로 평가된다.' },
        { id: 'section-3', title: '사료 분석: 동해 표기', status: 'draft', statusLabel: '초안', words: 920,
          content: '동해 표기 논쟁은 조선 후기 해도, 유럽 고지도, IHO S-23 초판(1929), S-130 결정(2020)을 시간축으로 추적한다. 1929년 S-23 채택 당시 한국이 일본 식민 지배 하에 있어 의견 개진이 불가능했다는 역사적 맥락을 명시한다.' },
        { id: 'section-4', title: '역사왜곡 현황 분석', status: 'draft', statusLabel: '초안', words: 680,
          content: '2025-2026년 탐지된 역사왜곡 콘텐츠의 유형·매체·언어별 분포를 정량적으로 분석한다. 특히 영문 매체와 SNS에서의 왜곡 확산 패턴, 교과서 서술 변경 동향을 중점 검토한다.' },
        { id: 'section-5', title: '대응 전략 제안', status: 'outline', statusLabel: '개요만', words: 240,
          content: '분석 결과를 바탕으로 단기(반박 콘텐츠 생산), 중기(국제 학술 네트워크 구축), 장기(디지털 아카이브 체계화) 대응 전략을 3단계로 제안한다.' },
        { id: 'section-6', title: '부록: 사료 목록', status: 'outline', statusLabel: '개요만', words: 150,
          content: '본 보고서에서 인용한 사료의 전체 목록과 출처 정보를 정리한다.' }
    ];

    public citations: any[] = [
        { title: '대한제국 칙령 제41호', source: '원문 12p', tag: '법령', quote: '울도군의 구역을 울릉전도, 죽도, 석도(독도)를 관할한다.', section: '서론', linked: true },
        { title: '태정관 지령 (1877)', source: '일본 국립공문서관', tag: '정부문서', quote: '竹島 外一島ノ義ハ本邦関係無之義ト可相心得事', section: '사료 분석: 독도 영유권', linked: true },
        { title: 'SCAPIN 제677호', source: '연합군 사령부', tag: '외교', quote: '일본 행정권 범위에서 독도를 명시적으로 제외.', section: '사료 분석: 독도 영유권', linked: true },
        { title: '조선 후기 해도 컬렉션', source: '동해표기-03', tag: '지도', quote: '동해 명칭 사용 사례가 연속적으로 확인된다.', section: '사료 분석: 동해 표기', linked: true },
        { title: '국제수로기구 S-23 초판', source: 'IHO archive', tag: '표준', quote: '1929년 일본해 단독 표기 채택.', section: '사료 분석: 동해 표기', linked: false },
        { title: 'IHO S-130 결정문 (2020)', source: 'IHO archive', tag: '표준', quote: '디지털 방식 전환, 고유 번호 기반 해역 식별.', section: '사료 분석: 동해 표기', linked: true },
        { title: '피해자 증언 기록집', source: '국사편찬위원회', tag: '증언', quote: '강제 동원 관련 진술 92건 수록.', section: '역사왜곡 현황 분석', linked: false },
        { title: '고노 담화 (1993)', source: '일본 외무성', tag: '외교', quote: '일본 정부의 위안부 강제성 공식 인정.', section: '역사왜곡 현황 분석', linked: true },
        { title: 'UN 인권위원회 권고 (2024)', source: 'UNHRC', tag: '국제법', quote: '역사 교육에서의 정확성·중립성 권고.', section: '대응 전략 제안', linked: false },
        { title: '1877년 시마네현 질의서', source: '일본 국립공문서관', tag: '행정문서', quote: '울릉도와 독도의 귀속에 대한 공식 질의.', section: '사료 분석: 독도 영유권', linked: true }
    ];

    public versions: any[] = [
        { label: 'v1.2 — 독도 섹션 보강', time: '5분 전', author: '연구자', current: true, changes: '+480자' },
        { label: 'v1.1 — AI 초안 완성', time: '30분 전', author: 'AI 생성', current: false, changes: '+920자' },
        { label: 'v1.0 — 구조 확정', time: '2시간 전', author: '연구자', current: false, changes: '섹션 재편' },
        { label: 'v0.9 — 서론 수정', time: '3시간 전', author: '연구자', current: false, changes: '서론 방향 변경' },
        { label: 'v0.8 — 자료 정리', time: '어제', author: 'AI 생성', current: false, changes: '인용 추가' },
        { label: 'v0.7 — 초기 구조', time: '2일 전', author: 'AI 생성', current: false, changes: '초기 생성' }
    ];

    public basket: any[] = [
        { title: '독도 관련 영문 기사 반박 자료', count: 5, tag: '독도' },
        { title: '안용복 사료 묶음', count: 8, tag: '독도' },
        { title: '동해 병기 국제 문서', count: 3, tag: '동해' },
        { title: '태정관 지령 관련 문서', count: 4, tag: '독도' },
        { title: '위안부 증언·문서 아카이브', count: 12, tag: '위안부' },
        { title: '일본 교과서 변화 추적 자료', count: 6, tag: '교과서' }
    ];

    public exportFormats: any[] = [
        { id: 'word', label: 'Word' },
        { id: 'pdf', label: 'PDF' },
        { id: 'hwp', label: 'HWP' },
        { id: 'md', label: 'Markdown' }
    ];

    public comments: any[] = [
        { author: '박연구원', time: '1시간 전', section: '서론', text: '연구 범위에 간도 문제도 포함하는 것은 어떨까요?', resolved: false },
        { author: '김팀장', time: '3시간 전', section: '사료 분석: 독도 영유권', text: '태정관 지령 원문 이미지를 부록에 첨부해주세요.', resolved: false },
        { author: 'AI', time: '30분 전', section: '역사왜곡 현황 분석', text: '2026년 1분기 왜곡 탐지 건수 통계를 추가하면 설득력이 강화됩니다.', resolved: true }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (location.pathname === '/reports') {
            this.service.href('/studio');
            return;
        }
        await this.service.auth.allow('/access');
        await this.service.render();
    }

    public get activeSection() {
        return this.sections.find((s: any) => s.id === this.activeSectionId) || this.sections[0];
    }

    public get totalWords(): number {
        return this.sections.reduce((sum: number, s: any) => sum + s.words, 0);
    }

    public get readyCount(): number {
        return this.sections.filter((s: any) => s.status === 'ready').length;
    }

    public get progress(): number {
        return Math.round((this.readyCount / this.sections.length) * 100);
    }

    public get sectionCitations() {
        return this.citations.filter((c: any) => c.section === this.activeSection.title);
    }

    public get unresolvedComments() {
        return this.comments.filter((c: any) => !c.resolved).length;
    }

    public async selectSection(id: string) {
        this.activeSectionId = id;
        await this.service.render();
    }

    public async setTab(tab: string) {
        this.rightTab = tab;
        await this.service.render();
    }

    public async toggleAiPanel() {
        this.showAiPanel = !this.showAiPanel;
        if (this.showAiPanel && !this.aiSuggestion) {
            this.aiSuggestion = '이 섹션에 태정관 지령의 역사적 맥락을 보충하면 논거가 강화됩니다. 시마네현 질의서 → 내무성 상신 → 태정관 결정의 순서를 시간축으로 서술하는 것을 권장합니다.';
        }
        await this.service.render();
    }

    public async resolveComment(idx: number) {
        this.comments[idx].resolved = true;
        await this.service.render();
    }

    public statusDot(status: string) {
        return { draft: 'bg-amber-400', ready: 'bg-emerald-400', outline: 'bg-stone-300 dark:bg-stone-600' }[status] || 'bg-stone-300';
    }

    public statusBadge(status: string) {
        return {
            draft: 'text-amber-700 bg-amber-50 dark:text-amber-300 dark:bg-amber-900/20',
            ready: 'text-emerald-700 bg-emerald-50 dark:text-emerald-300 dark:bg-emerald-900/20',
            outline: 'text-stone-600 bg-stone-100 dark:text-stone-400 dark:bg-stone-800'
        }[status] || 'text-stone-600 bg-stone-100';
    }
}

export default PageReportsComponent;